import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const proficienciesReducer = createAsyncReducer({
    name: 'proficiencies',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        loadByIdentity: create.asyncThunk(
            async (identity) => {
                return await Fetch.get(Routes.ajax_proficiency_path(identity));
            }, {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.loading = false;
                    state.errorMessage = message;
                }
            }
        ),
        loadByIds: create.asyncThunk(
            async (proficiencyIds) => {
                return await Fetch.get(Routes.ajax_proficiencies_path({ proficiency_ids: proficiencyIds }));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.loading = false;
                }
            }
        ),
        loadByCertificationId: create.asyncThunk(
            async (certId) => {
                return await Fetch.get(Routes.ajax_certification_proficiencies_path(certId))
                .then((proficiencyIds) => Fetch.get(Routes.ajax_proficiencies_path({ proficiency_ids: proficiencyIds })));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.loading = false;
                }
            }
        )
    })
});

export default proficienciesReducer;